import axios from "axios"
import { GetSubCatResponse } from "./response/GetSubCatResponse";
import { GetForecastResponse } from "./response/GetForecastResponse";
import { GetImageResponse } from "./response/GetImageResponse";
import { GetInfoResponse } from "./response/GetInfoResponse";
import { GetNavbarCategoriesReponse } from "./response/GetNavbarCategoriesResponse";
import { GetPortalResponse } from "./response/GetPortalResponse";
import { GetCatgoryResponse } from "./response/GetCategoryResponse";
import { GetDepartmentResponse } from "./response/GetDepartmentResponse";
import { WeatherInfo } from "./response/GetWeatherInfoResponse";
import { GetWeatherWarningResponse } from "./response/GetWeatherWarningResponse";
import { GetGeneralResponse } from "./response/GetGeneralResponse";
import { GetLogResponse } from "./response/GetLogResponse";
import { CategoryMap } from "../components/category-navbar";

export interface APIResponse {
    success: boolean;
    json: string;
    err: string;
    obj?: any;
}

export const APIPath = {
    // BasePath: 'http://localhost:5278', //LOCAL
    // BasePath: 'http://hkcwebd01:8088', //DEMO
    BasePath: 'https://www.hkconnections.com.hk:8080', ////PROD
    ImageStorage: {
        GetHomepageCover: '/img/home',
        GetRandomImage: '/img/random',
        GetCategoryCover: '/img/getCatCover',
        GetDeptCover: '/img/getDeptCover',
        GetSubCatCovers: '/img/getSubcatCovers',
        GetProduct: '/img/getProducts',
        Search: '/img/search',
        Get: '/img/find'
    },
    Category: {
        Navbar: '/cat/getNew',
        GetCat: '/cat/get',
        GetCatByDept: '/cat/getCatByDept',
        GetDepartment: '/cat/getDeptByCat',
        GetDepartmentInfo: '/cat/getDeptById',
        GetDeptBySubCat: '/cat/getDeptBySubCat',
        GetSubCatInfo: '/cat/getSubCatById',
        GetSubCatBySKU: '/cat/getSubCatBySKU'
    },
    Info: {
        GetInfo: '/info',
        GetUsefulLinks: '/portal/getByDept?key=V'
    },
    External: {
        GetForecast: 'https://data.weather.gov.hk/weatherAPI/opendata/weather.php?dataType=rhrread&lang=',
        GetWeatherWarning: 'https://data.weather.gov.hk/weatherAPI/opendata/weather.php?dataType=warnsum&lang=',
        GetWeatherInfo: 'https://data.weather.gov.hk/weatherAPI/opendata/weather.php?dataType=flw&lang=',
        GetDailyVerse: 'https://dailyverses.net/get/verse.js?language='
    },
    Portal: {
        GetAll: '/portal'
    },
    Admin: {
        SyncImage: '/admin/sync',
        GetSyncImageLog: '/log/syncImage'
    }
}

const API = {
    ImageStorage: {
        GetHomepageCover: async () => {
            const res = await CallAPI(`${APIPath.ImageStorage.GetHomepageCover}`)
            if (res.success) {
                const obj: GetImageResponse = { items: JSON.parse(res.json!!) }
                res.obj = obj
                res.json = ''
            }
            return res
        },
        GetRandomImage: async () => {
            const res = await CallAPI(`${APIPath.ImageStorage.GetRandomImage}`)
            if (res.success) {
                const obj: GetImageResponse = { items: JSON.parse(res.json!!) }
                res.obj = obj
                res.json = ''
            }
            return res
        },
        GetCategoryCover: async (cat: string) => {
            const res = await CallAPI(`${APIPath.ImageStorage.GetCategoryCover}?key=${cat.toUpperCase()}`)
            if (res.success) {
                const obj: GetImageResponse = { items: JSON.parse(res.json!!) }
                res.obj = obj
                res.json = ''
            }
            return res

        },
        GetDeptCover: async (dept: string) => {
            const res = await CallAPI(`${APIPath.ImageStorage.GetDeptCover}?key=${dept.toUpperCase()}`)
            if (res.success) {
                const obj: GetImageResponse = { items: JSON.parse(res.json!!) }
                res.obj = obj
                res.json = ''
            }
            return res

        },
        GetSubCatList: async (dept: string) => {
            const res = await CallAPI(`${APIPath.ImageStorage.GetSubCatCovers}?key=${dept.toUpperCase()}`)
            if (res.success) {
                const obj: GetImageResponse = { items: JSON.parse(res.json!!) }
                res.obj = obj
                res.json = ''
            }
            console.log("ASADAD")
            console.log(dept.toUpperCase())
            return res

        },
        GetSubCat: async (sub: string) => {
            const res = await CallAPI(`${APIPath.ImageStorage.GetProduct}?key=${sub.toLowerCase()}`)
            if (res.success) {
                const obj: GetImageResponse = { items: JSON.parse(res.json!!) }
                res.obj = obj
                res.json = ''
            }
            return res

        },
        // GetProduct: async (p: string) => {
        //     const res = await CallAPI(`${APIPath.ImageStorage.GetProduct}/${p.toLowerCase()}`)
        //     if (res.success) {
        //         const obj: GetImageResponse = { items: JSON.parse(res.json!!) }
        //         res.obj = obj
        //         res.json = ''
        //     }
        //     return res

        // },
        Search: async (key: string) => {
            const res = await CallAPI(`${APIPath.ImageStorage.Search}?key=${key}`)
            if (res.success) {
                const obj: GetImageResponse = { items: JSON.parse(res.json!!) }
                res.obj = obj
                res.json = ''
            }
            return res

        },
        Get: async (key: string) => {
            const res = await CallAPI(`${APIPath.ImageStorage.Get}?key=${key}`)
            if (res.success) {
                const obj: GetImageResponse = { items: JSON.parse(res.json!!) }
                res.obj = obj
                res.json = ''
            }
            return res
        }
    },
    Category: {
        GetNavbarCategories: async () => {
            const res = await CallAPI(APIPath.Category.Navbar)
            if (res.success) {
                const obj: GetNavbarCategoriesReponse = { items: JSON.parse(res.json!!) }
                res.obj = obj
                res.json = ''
                console.log(res)
            }
            
            return res
        },
        GetCat: async (cat: string) => {
            const res = await CallAPI(APIPath.Category.GetCat + `?key=${cat.toUpperCase()}`)
            if (res.success) {
                const obj: GetCatgoryResponse = { items: JSON.parse(res.json!!) }
                res.obj = obj
                res.json = ''
            }
            return res
        },
        GetCatByDept: async (dept: string) => {
            const res = await CallAPI(APIPath.Category.GetCatByDept + `?key=${dept.toUpperCase()}`)
            console.log(res)
            if (res.success) {
                const obj: { category_id: string } = JSON.parse(res.json!!)
                res.obj = obj
                res.json = ''
            }
            return res
        },
        GetDepartments: async (cat: string) => {
            const res = await CallAPI(APIPath.Category.GetDepartment + `?key=${cat.toUpperCase()}`)
            if (res.success) {
                const obj: GetDepartmentResponse = { items: JSON.parse(res.json!!) }
                res.obj = obj
                res.json = ''
            }
            return res
        },
        GetDepartmentInfo: async (dept: string) => {
            const res = await CallAPI(APIPath.Category.GetDepartmentInfo + `?key=${dept.toUpperCase()}`)
            if (res.success) {
                const obj: GetDepartmentResponse = { items: JSON.parse(res.json!!) }
                res.obj = obj
                res.json = ''
            }
            return res
        },
        // GetSubCatBySKU: async (sku: string) => {
        //     const res = await CallAPI(APIPath.Category.GetSubCatBySKU + `/${sku}`)
        //     if (res.success) {
        //         const obj: GetImageResponse = { items: JSON.parse(res.json!!) }
        //         res.obj = obj
        //         res.json = ''
        //     }
        //     return res
        // },
        GetDeptBySubCat: async (sc: string) => {
            const res = await CallAPI(APIPath.Category.GetDeptBySubCat + `?key=${sc.toUpperCase()}`)
            if (res.success) {
                const obj: { dept_id: string } = JSON.parse(res.json!!)
                res.obj = obj
                res.json = ''
            }
            return res
        },
        GetSubCatInfo: async (subcat: string) => {
            const res = await CallAPI(APIPath.Category.GetSubCatInfo + `?key=${subcat.toUpperCase()}`)
            if (res.success) {
                const obj: GetSubCatResponse = { items: JSON.parse(res.json!!) }
                res.obj = obj
                res.json = ''
            }
            return res
        }
    },
    Info: {
        GetInfo: async (key: string) => {
            const res = await CallAPI(APIPath.Info.GetInfo + `?key=${key.toLowerCase()}`)
            if (res.success) {
                const obj: GetInfoResponse = JSON.parse(res.json!!)
                res.obj = obj
                res.json = ''
            }
            return res
        },
        GetUsefulLinks: async () => {
            const res = await CallAPI(APIPath.Info.GetUsefulLinks)
            if (res.success) {
                const obj: GetPortalResponse = { items: JSON.parse(res.json!!) }
                res.obj = obj
                res.json = ''
            }
            return res
        }
    },
    External: {
        GetForecarst: async (locale: string) => {
            let hkoLocale = 'en'
            if (locale == 'zh') {
                hkoLocale = 'tc'
            }
            if (locale == 'cn') {
                hkoLocale = 'sc'
            }
            const res = await CallAPI(APIPath.External.GetForecast + hkoLocale, undefined, { external: true })
            if (res.success) {
                const obj: GetForecastResponse = JSON.parse(res.json!!)
                res.obj = obj
                res.json = ''
            }
            return res
        },
        GetWeatherInfo: async (locale: string) => {
            let hkoLocale = 'en'
            if (locale == 'zh') {
                hkoLocale = 'tc'
            }
            if (locale == 'cn') {
                hkoLocale = 'sc'
            }
            const res = await CallAPI(APIPath.External.GetWeatherInfo + hkoLocale, undefined, { external: true })
            if (res.success) {
                const obj: WeatherInfo = JSON.parse(res.json!!)
                res.obj = obj
                res.json = ''
            }
            return res
        },
        GetWeatherWarning: async (locale: string) => {
            let hkoLocale = 'en'
            if (locale == 'zh') {
                hkoLocale = 'tc'
            }
            if (locale == 'cn') {
                hkoLocale = 'sc'
            }
            const res = await CallAPI(APIPath.External.GetWeatherWarning + hkoLocale, undefined, { external: true })
            if (res.success) {
                const obj: GetWeatherWarningResponse =
                    { items: Object.entries(JSON.parse(res.json)).map((x) => { return { key: x[0], name: JSON.parse(JSON.stringify(x[1])).name, code: JSON.parse(JSON.stringify(x[1])).code } }) }
                res.obj = obj
                res.json = ''
            }
            return res
        },
        GetDailyVerse: async (locale: string) => {
            let dvLocale = 'niv'
            if (locale == 'zh' || locale == 'cn') {
                dvLocale = 'cuv'
            }
            const res = await CallAPI(APIPath.External.GetDailyVerse + dvLocale, undefined, { external: true })
            if (res.success) {
                res.obj = res.json.split('\\u003e')
                res.json = ''
            }
            return res
        }
    },
    Portal: {
        GetAll: async () => {
            const res = await CallAPI(APIPath.Portal.GetAll)
            if (res.success) {
                const obj: GetPortalResponse = { items: JSON.parse(res.json!!) }
                res.obj = obj
                res.json = ''
            }
            return res
        }
    },
    Admin: {
        SyncImage: async (user?: string) => {
            const key = user ?? 'admin'
            const res = await CallAPI(`${APIPath.Admin.SyncImage}?user=${key}`)
            if (res.success) {
                const obj: GetGeneralResponse = JSON.parse(res.json!!)
                res.obj = obj
                res.json = ''
            }
            return res
        },
        GetSyncImageLog: async () => {
            const res = await CallAPI(`${APIPath.Admin.GetSyncImageLog}`)
            if (res.success) {
                const obj: GetLogResponse = { items: JSON.parse(res.json!!)}
                res.obj = obj
                res.json = ''
            }
            return res
        },
    }
}

const BasicOptions: RequestInit = {
    method: 'GET',
    mode: 'no-cors',
    // headers: {
    //     "Content-Type" : "application/json",
    //     "Access-Control-Allow-Headers" : "Content-Type",
    //     "Access-Control-Allow-Origin": "*",
    // },
    // body: undefined
}

interface APIOption {
    external?: boolean
    simpleResponse?: boolean
}

const CallAPI = async (path: string, data?: any, extra?: APIOption): Promise<APIResponse> => {
    const useExternal = extra ? extra.external ?? false : false
    const simpleRes = extra ? extra.simpleResponse ?? false : false
    const option = BasicOptions
    try {
        if (data) {
            option.method = 'POST'
            option.body = JSON.stringify(data)
            const res = await fetch(`${useExternal ? '' : APIPath.BasePath}${path}`, option)
            return { success: true, json: simpleRes ? await res.json() : JSON.stringify(await res.json()), err: '' }
        } else {
            console.log(`${useExternal ? '' : APIPath.BasePath}${path}`);
            const res = await fetch(`${useExternal ? '' : APIPath.BasePath}${path}`)
            console.log(res);
            return { success: true, json: simpleRes ? await res.json() : JSON.stringify(await res.json()), err: '' }
        }
    } catch (err) {
        console.log((err))
        return { success: false, json: '', err: JSON.stringify(err) }
    }
}

const EscapeSpecialChar = (str: string) => {
    console.log(str.indexOf('\''))
    let build = str
    build = build.replace("'", "\\'")
    return build
}

export default API